<template>
  <div class="app-content">
    <AppPageTitle></AppPageTitle>
    <Content class="app-content__main">
      <Tabs value="name1">
        <TabPane label="订购明细" name="name1">
          <Form ref="formValidate" :model="formValidate" :label-width="110">
            <Row>
              <Col :md="8" :sm="12" :xs="24">
                <FormItem label="代理商:" prop="agentName">
                  <Select v-model="formValidate.agentId" clearable style="width: 100%;">
                    <Option v-for="item in agentList" :value="item.value" :key="item.value">{{ item.label }}</Option>
                  </Select>
                </FormItem>
              </Col>
              <Col :md="8" :sm="12" :xs="24">
                <FormItem label="订购状态:" prop="nodeState">
                  <Select v-model="formValidate.status" clearable style="width: 100%;">
                    <Option v-for="item in stateList" :value="item.value" :key="item.value">{{ item.label }}</Option>
                  </Select>
                </FormItem>
              </Col>
              <Col :md="8" :sm="12" :xs="24">
                <FormItem label="订购时间:" prop="queryDate">
                  <DatePicker type="datetimerange" v-model="queryDate" placeholder="订购时间" style="width: 500px" />
                </FormItem>
              </Col>
              <Col :md="8" :sm="12" :xs="24">
                <FormItem label="手机号:" prop="mobile">
                  <Input v-model="formValidate.mobile" placeholder="手机号" style="width: 100%;" />
                </FormItem>
              </Col>
              <Col :md="8" :sm="12" :xs="24">
                <FormItem label="产品ID:" prop="mobile">
                  <Input v-model="formValidate.offerId" placeholder="手机号" style="width: 100%;" />
                </FormItem>
              </Col>
              <Col :md='24' class="text-right">
                <Button type="primary" @click="formSubmit" icon="md-search" style="margin: 0 8px 16px 16px;">查询</Button>
                <Button type="default" @click="formReset" style="margin: 0 0 16px 0;">重置</Button>
              </Col>
            </Row>
          </Form>
          <Row>
            <Col :md='24' style="margin-bottom: 20px">
              <Button
                type="info"
                icon="md-download"
                style="margin-right: 8px"
                :disabled="!queryData.length"
                @click="exportOrder"
              >导出</Button>
            </Col>
          </Row>
          <Table
            :columns="queryColumn"
            :loading="loading"
            :data="queryData"
            border
            ref="dataTable"
          >
            <template slot-scope="{row}" slot="status">
            <!--          <div>{{row.status === 0 ? '订购中' : (row.status === 1? '订购成功' : '订购失败')}}</div>-->
            <Tag color="blue" v-if="row.status === 0">订购中</Tag>
            <Tag color="cyan" v-else-if="row.status === 1">订购成功</Tag>
            <Tag color="red" v-else>订购失败</Tag>
          </template>
          </Table>
          <Row>
            <Col :md="24" class="pagination">
              <Page
                :total="totalPage"
                :page-size="pageSize"
                :current="pageNum"
                :disabled="loading"
                @on-change="pageChange"
                @on-page-size-change="pageSizeChange"
                show-elevator show-sizer show-total />
            </Col>
          </Row>
        </TabPane>
        <TabPane label="续订明细" name="name2">
          <product-order-details />
        </TabPane>
      </Tabs>
    </Content>
    <ExportFile ref="exportFile" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '../../api'
import utils from '../../utils'
import RechargeStatus from '../../components/order/RechargeStatus'
import ExportFile from '../../components/common/ExportFile'
import ProductOrderDetails from "@/views/product/ProductOrderDetails.vue";
import Management from "@/views/order/Management.vue";

export default {
  components: {
    Management,
    ProductOrderDetails,
    RechargeStatus,
    ExportFile
  },
  data () {
    return {
      formValidate: {
        agentId: null,
        nodeState: null,
        offerId: ''
      },
      queryDate: [],
      queryData: [],
      loading: false,
      totalPage: 1,
      pageSize: 10,
      pageNum: 1,
      stateList: [
        {
          value: 0,
          label: '订购中'
        },
        {
          value: 1,
          label: '订购成功'
        },
        {
          value: -1,
          label: '订购失败'
        },
        {
          value: 2,
          label: '已退订'
        }
      ]
    }
  },
  computed: {
    startDate () {
      return this.queryDate[0] ? this.queryDate[0].getTime() : null
    },
    endDate () {
      return this.queryDate[1] ? this.queryDate[1].getTime() : null
    },
    startDateText () {
      return this.startDate ? utils.formatDateTime(this.startDate) : null
    },
    endDateText () {
      return this.endDate ? utils.formatDateTime(this.endDate) : null
    },
    ...mapGetters('recharge', ['rechargeStatus']),
    queryColumn () {
      return [
        {
          title: '平台订单号',
          key: 'tradeNo',
          minWidth: 170
        },
        {
          title: '代理商名称',
          key: 'agentName',
          minWidth: 150
        },
        {
          title: '产品编号',
          key: 'offerId',
          align: 'center',
          width: 110
        },
        {
          title: '手机号',
          key: 'phone',
          width: 150,
          align: 'center'
        },
        {
          title: '创建时间',
          key: 'createDate',
          minWidth: 150,
          align: 'center',
          render: (h, params) => {
            return h('span', utils.formatDateTime(params.row.createDate))
          }
        },
        {
          title: 'orderId',
          key: 'orderId',
          minWidth: 120,
          align: 'center'
        },
        {
          title: 'tradeId',
          key: 'tradeId',
          minWidth: 120,
          align: 'center'
        },
        {
          title: '订购状态',
          key: 'status',
          width: 120,
          slot: 'status',
          align: 'center'
        },
        {
          title: '失败原因',
          key: 'errMsg',
          minWidth: 190,
          align: 'center'
        }
      ]
    }
  },
  methods: {
    formSubmit () {
      // 判断开始时间和结束时间
      if (this.startDate && this.endDate && (this.startDate >= this.endDate)) {
        this.$Message.error('开始时间不能大于或等于结束时间！')
        return
      } else if (this.startDate && !this.endDate) {
        this.$Message.error('请选择结束时间！')
        return
      } else if (!this.startDate && this.endDate) {
        this.$Message.error('请选择开始时间！')
        return
      }
      this.pageNum = 1
      this.pageSize === 10 ? this.getData() : this.pageSize = 10
    },
    formReset () {
      this.$refs['formValidate'].resetFields()
      this.queryDate = []
      this.formSubmit()
    },
    getData () {
      this.loading = true
      let date = {
        startDate: this.startDate,
        endDate: this.endDate
      }
      api.order.productOrderPage({
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        ...date,
        ...this.formValidate
      })
        .then((res) => {
          this.loading = false
          this.totalPage = +res.data.total
          this.queryData = res.data.records || []
        })
        .catch((err) => {
          this.loading = false
          this.$Message.error('获取订单列表失败: ' + err.message)
        })
    },
    pageChange (pageNum) {
      this.pageNum = pageNum
      this.getData()
    },
    pageSizeChange (pageSize) {
      this.pageSize = pageSize
      this.pageNum === 1 ? this.getData() : this.pageNum = 1
    },
    // 导出
    exportOrder () {
      let params = {}
      for (const item in this.formValidate) {
        if (this.formValidate.hasOwnProperty(item)) {
          if (this.formValidate[item] !== '' && this.formValidate[item] !== null) {
            if (item === 'startDate' || item === 'endDate') {
              params[item] = new Date(this.formValidate[item]).getTime()
            } else {
              params[item] = this.formValidate[item]
            }
          }
        }
      }

      params.startDate = this.startDate
      params.endDate = this.endDate
      params.pageNum = this.pageNum
      params.pageSize = 100
      this.$refs.exportFile.submit(api.order.productOrderOut, 'get', {
        ...params
      })
    }
  },
  created () {
    this.getData()
    api.agent.agentList({
      pageNum: 1,
      pageSize: 100
    })
      .then((res) => {
        this.agentList = res.data.records
          .map(item => ({
            value: item.id,
            label: item.agentName
          })) || []
      })
      .catch((err) => {
        this.$Message.error('获取代理商列表失败: ' + err.message)
      })
  }
}
</script>
